module.exports = __webpack_public_path__ + "img/9_52.a6543d34.png";